import { Component, OnInit } from '@angular/core';
import { AuthServiceCustom, GridConfigItem } from 'src/shared/service/auth.service';
import { AbstractDataProvider } from '../AbstractDataProvider';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SortDescriptor } from '@progress/kendo-data-query';
import { Config, Fund, FundAndYears, Investment } from '../../shared/model/interfaces';
import { GenericFilterModel } from '../security/QueryStringParam';
import { finalize } from 'rxjs/operators';
import {getErrorMessageText} from '../helper';


@Component({
  selector: 'app-investments',
  templateUrl: './investments.component.html',
  styleUrls: ['./investments.component.scss']
})
export class InvestmentsComponent implements OnInit {
  public introText: string;
  public ActiveInvestments = [];
  public InActiveInvestments = [];
  display = false;
  alertMessage: string;
  allInvestments: Array<Investment> = [];

  public loading: boolean;
  public sort: SortDescriptor[];
  funds: Fund[] = [];
  isActiveOnly: boolean;
  fund = '';
  config: Config;


  constructor(
    private abstractDataProvider: AbstractDataProvider,
    private ngxService: NgxUiLoaderService,
    private authService: AuthServiceCustom
  ) {
    this.config = this.authService.getGridColumnConfigs(GridConfigItem.INVESTOR);
    if (this.config.allowSort) {
      this.sort = [this.config.defaultSort];
    }
  }

  ngOnInit() {
    this.abstractDataProvider.getData('api/Tax/GetFundAndYears').subscribe((data: FundAndYears) => {
        this.funds = data.Funds;
      },
      error => {
        this.display = true;
        this.alertMessage = error.message;
      })
      .add(() => {
        this.makeAPICallGetData();
        this.getIntroText();
      });
  }

  search() {
    this.allInvestments = [];
    this.loading = true;
    this.makeAPICallGetData();
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.search();
  }

  getIntroText(): void {
    this.introText = this.authService.getIntroText('INVESTMENTS', this.funds?.map(x => x.FundId));
  }

  onConfirm(): void {
    this.display = false;
  }

  private makeAPICallGetData(): void {
    const genericFilterModel: GenericFilterModel = {
      Filters: [
        {Key: 'fund', Value: this.fund},
        {Key: 'activeOnly', Value: Boolean(this.isActiveOnly).toString()},
      ],
      PageNo: null,
      PageSize: null,
      SortField: null,
      SortOrder: null,
      SkipRecords: null
    };

    if (this.config.allowSort) {
      genericFilterModel.SortField = this.sort[0].field;
      genericFilterModel.SortOrder = this.sort[0].dir;
    }

    this.abstractDataProvider.postData(genericFilterModel, 'api/Investment/GetInvestmentDetailsRecords')
      .pipe(
        finalize(() => this.loading = false))
      .subscribe((investment) => {
          this.allInvestments = investment.LstnvestmentPortfolios;

          if (this.ActiveInvestments && this.ActiveInvestments.length > 0) {
            this.ActiveInvestments.forEach((inv) => {
              this.allInvestments.push(inv);
            });
          }
          if (this.InActiveInvestments && this.InActiveInvestments.length > 0) {
            this.InActiveInvestments.forEach((inv) => {
              this.allInvestments.push(inv);
            });
          }
        },
        error => {
          this.display = true;
          this.alertMessage =  getErrorMessageText(error);
        }
      );
  }
}
